<main class="body-main d-none">
  <section class="log-in">
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <div class="login-left" style="
              background-image: url('./assets/images/login/login-left-back.png');
            ">
            <h1>Syncinns –The Next-Gen Travel Distribution Platform</h1>
            <img src="assets/images/login/login-left-2.png" alt="" class="img-fluid" />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="login-right">
            <!-- <h4>Syncinns</h4> -->
            <div class="brand-logo my-2">
              <img src="../../../assets/icon/logo.png" alt="Logo" />
            </div>
            <h6>Forgot your password</h6>
            <p>Please enter your registered email to continue</p>
            <div class="login-form">
              <form [formGroup]="forgotpassForm" (ngSubmit)="submit()">
                <div class="row form-rw">
                  <div class="col-12 login-form-input">
                    <label>Email</label>
                    <input type="email" formControlName="email" placeholder="Enter your email" [class.is-invalid]="
                        f['email'].touched && f['email'].invalid
                      " />
                    <span><img src="assets/images/login/mail.svg" alt="" /></span>
                    <div class="invalid-feedback" *ngIf="f['email'].touched && f['email'].errors">
                      <div *ngIf="f['email'].errors['required']">
                        Email is required
                      </div>
                      <div *ngIf="f['email'].errors['email']">
                        Please enter a valid email address
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row form-rw">
                  <div class="col-12 login-form-input">
                    <label class="unique-checkbox-label">
                      <!--
                      <input type="checkbox" class="unique-remember-checkbox" formControlName="isCustomer" />
                      -->
                      <input type="checkbox" class="unique-remember-checkbox" />
                      <span class="custom-checkbox-box"></span>
                      Are you a customer?
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <!-- <input type="submit" value="Send Code"> -->
                    <button class="login-cmn-button" [disabled]="forgotpassForm.invalid">
                      Send Code
                    </button>
                  </div>
                </div>
              </form>
              <div class="social-list">
                <ul>
                  <li>
                    <a href="https://www.linkedin.com/company/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/linkdin.png" alt="LinkedIn" />
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/devicontwitter.png" alt="Twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/facebook.png" alt="Facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/syncinns/" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/instragram.png" alt="Instagram" />
                    </a>
                  </li>
                </ul>
              </div>
              <p>Remember password? <a routerLink="/login">Sign In</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<section class="common-login-section">
  <div class="lang-switcher-floating" [attr.dir]="translationService.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <p-select [options]="langOptions" [(ngModel)]="selectedLang" optionLabel="name" optionValue="value"
      [showClear]="false" appendTo="body" panelStyleClass="lang-switcher-panel" (onChange)="onLangChange($event.value)">
  
      <ng-template #selectedItem let-selectedOption>
        <div class="lang-selected">
          <img src="assets/images/flags/flag_placeholder.png" alt="{{ selectedOption.name }}"
            [class]="'flag flag-' + selectedOption.code.toLowerCase()" />
          <span>{{ selectedOption.name }}</span>
        </div>
      </ng-template>
  
      <ng-template let-lang #item>
        <div class="d-flex align-items-center gap-2">
          <img alt="{{ lang.name }}" src="assets/images/flags/flag_placeholder.png"
            [class]="'flag flag-' + lang.code.toLowerCase()" style="width: 18px" />
          <div>{{ lang.name }}</div>
        </div>
      </ng-template>
    </p-select>
  </div>
  <div class="imgtexture">
    <div class="imginfobox">
      <img src="assets/images/login/texture.png" alt="" />
      <img src="assets/images/login/texture.png" alt="" />
    </div>
  </div>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 col-12">
        <div class="tpfLoginContainer">
          <h2 class="tpfLoginTitle">{{ 'forgotPassword.title' | translate }}</h2>
          <p class="tpfLoginSub">{{ 'forgotPassword.subtitle' | translate }}</p>
          <div class="login-form">
            <form [formGroup]="forgotpassForm" (ngSubmit)="submit()">
              <div class="tpfInputGroup-main">
                <div class="tpfInputGroup">
                  <!-- <label>Email</label> -->
                  <input type="email" formControlName="email" [placeholder]="'forgotPassword.emailPlaceholder' | translate" [class.is-invalid]="
                      f['email'].touched && f['email'].invalid
                    " />
                  <span class="icospan"><img src="assets/images/login/email.svg" alt="" /></span>
                  <div class="invalid-feedback" *ngIf="f['email'].touched && f['email'].errors">
                    <div *ngIf="f['email'].errors['required']">
                      {{ 'forgotPassword.emailRequired' | translate }}
                    </div>
                    <div *ngIf="f['email'].errors['email']">
                      {{ 'forgotPassword.invalidEmail' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="tpfInputGroup">
                <label class="unique-checkbox-label">
                  <input
                    type="checkbox"
                    class="unique-remember-checkbox"
                    formControlName="isCustomer"
                  />
                  <span class="custom-checkbox-box"></span>
                  Are you a customer?
                </label>
              </div> -->
              <div class="BOTTOMINFO">
                <div class="col-lg-12">
                  <button class="tpfLoginBtn" [disabled]="forgotpassForm.invalid">
                    {{ 'forgotPassword.sendCodeButton' | translate }}
                  </button>
                </div>
              </div>

              <div class="tpfLineWrap">
                <span><b>{{ 'forgotPassword.followLabel' | translate }}</b> {{ 'forgotPassword.followText' | translate }}</span>
              </div>

              <div class="social-listnew">
                <ul class="tpfSocialRow">
                  <li class="tpfSocial">
                    <a href="https://www.linkedin.com/company/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/linkdin.png" alt="LinkedIn" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://x.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/devicontwitter.png" alt="Twitter" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://www.facebook.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/facebook.png" alt="Facebook" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://www.instagram.com/syncinns/" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/instragram.png" alt="Instagram" />
                    </a>
                  </li>
                </ul>
              </div>
              <p>{{ 'forgotPassword.rememberPassword' | translate }} <a routerLink="/login">{{ 'forgotPassword.signIn' | translate }}</a></p>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 hidebox">
        <div class="new-colortexturebox">
          <img src="assets/images/login/newtexture.png" alt="" />
        </div>
        <div class="sync-banner-container">
          <div class="sync-slider-wrapper">
            <div class="abanimation">
              <img src="assets/images/login/thunderbolt.png" alt="" />
            </div>
            <div class="sync-slider">
              <!-- Slide 1 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{ 'forgotPassword.smartAnalyticsTitle' | translate }}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.roomOccupancyReports' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.roleBasedUserPermissions' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.enterpriseGradeSecurity' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.pricingAndRentalInvoices' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.housekeepingAutomation' | translate }}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide1.png" alt="" />
                  </div>
                </div>
              </div>

              <!-- Slide 2 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{ 'forgotPassword.carRentalManagementTitle' | translate }}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.vehicleAvailabilityTracking' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.driverAssignment' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.gpsAndTripLogs' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.pricingAndRentalInvoices' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.fleetMaintenanceReminders' | translate }}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide2.png" alt="" />
                  </div>
                </div>
              </div>

              <!-- Slide 3 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{ 'forgotPassword.whySyncinnsTitle' | translate }}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.hotelRoomBookingsAndOccupancy' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.guestManagementAndCrm' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.multiPropertyOperations' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.analyticsAndBusinessInsights' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.housekeepingAutomation' | translate }}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide3.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>